import { render } from "./PoliciesDetail.vue?vue&type=template&id=577ac2a0&ts=true"
import script from "./PoliciesDetail.vue?vue&type=script&lang=ts"
export * from "./PoliciesDetail.vue?vue&type=script&lang=ts"

import "./PoliciesDetail.vue?vue&type=style&index=0&id=577ac2a0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Profile/Policies/PoliciesDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "577ac2a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('577ac2a0', __exports__)) {
    api.reload('577ac2a0', __exports__)
  }
  
  module.hot.accept("./PoliciesDetail.vue?vue&type=template&id=577ac2a0&ts=true", () => {
    api.rerender('577ac2a0', render)
  })

}


export default __exports__